import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type UpdateImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationPatchData,
  type UpdateImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationPatchError,
  type UpdateImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationPatchResponse,
  updateImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationPatch,
} from '../../generated';

export type UpdateImageClassificationMutationVariables =
  UpdateImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationPatchData['path'] &
    UpdateImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationPatchData['body'];

export type UpdateImageClassificationMutation =
  UpdateImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationPatchResponse;

export const useUpdateImageClassificationMutation = <
  TError = UpdateImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationPatchError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<UpdateImageClassificationMutation, TError, UpdateImageClassificationMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<UpdateImageClassificationMutation, TError, UpdateImageClassificationMutationVariables, TContext>({
    mutationKey: ['UpdateImageClassification'],
    mutationFn: async ({ workspace_id, image_id, ...body }: UpdateImageClassificationMutationVariables) => {
      const { data } = await updateImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationPatch({
        path: { workspace_id, image_id },
        body,
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useUpdateImageClassificationMutation.fetcher = (
  { workspace_id, image_id, ...body }: UpdateImageClassificationMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await updateImageClassificationV1WorkspacesWorkspaceIdAssetsImagesImageIdClassificationPatch({
      path: { workspace_id, image_id },
      body,
      throwOnError: true,
    });
    return data;
  };
};
